import { BrowserModule } from '@angular/platform-browser';
import { inject, InjectionToken, Injector, NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { AppComponent } from './app.component';
// Import containers



import { LoginComponent } from './auth/login/login.component';

const APP_CONTAINERS = [
  DefaultLayoutComponent
  ,EmptyViewComponent
];


// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClient } from '@angular/common/http';
import { AppServicesModule } from '@solar/services/services.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { MaterialModule } from './shared/material.module';
import { ComponentsModule } from './components/components.module';
import { ChartModule } from 'fr-chart';
import { CountryPickerModule } from 'basecomponents';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { BaseComponentsModule } from 'basecomponents';
import { AuthenticationService } from '@solar/services/authentication.service';
import { AppInjector } from 'base-models';
import { AuthGuard, AUTH_SERVICE_PROVIDER_TOKEN } from 'baseauth';
import { environment } from '../environments/environment';
import { FileUploadModule } from 'guploadmgr';

import { JwtInterceptor } from 'fr-base-services';

import { ISSUE_IMAGE_BASE_DIR_TOKEN } from 'solar-bo';
import { AppSharedConfig } from 'solar-bo';
import { DefaultLayoutComponent } from './views/home';
import { AppReuseStrategy } from './shared/AppReuseStrategy';
import { EmptyViewComponent } from './views/emptyview/emptyview.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { mapcte, MAPS_CONFIG_TOKEN } from 'gmap';
import { AppConfig } from './app.config';
import { AppSettingsService } from './services/appsettings.service';



/* const AuthenticationFactory = (http: HttpClient) => {
  return new AuthenticationService(http);
};

const AUTH_SERVICE_TOKEN = new InjectionToken<AuthenticationService>('Manually constructed AuthenticationService', {
  providedIn: 'root',
  factory: () => new AuthenticationService(inject(HttpClient)),
});


export let AuthenticationProvider =
  { provide: AuthenticationService,
    useFactory: AuthenticationFactory,
    deps: [HttpClient]
  }; */


@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    AppRoutingModule,
    PerfectScrollbarModule
    ,BsDropdownModule.forRoot()
    ,TabsModule.forRoot()
    , MaterialModule
    /*,ButtonsModule.forRoot()*/
    ,BaseComponentsModule
    ,FileUploadModule.forRoot({baseUrl:environment.API_UPLOAD_ENDPOINT})
    , ComponentsModule.forRoot()
    , ChartModule.forRoot()
    , CountryPickerModule.forRoot({
      baseUrl: 'assets/'
    })
    ,AppServicesModule, ServiceWorkerModule.register('ngsw-worker.js', {
  enabled: environment.production,
  // Register the ServiceWorker as soon as the app is stable
  // or after 30 seconds (whichever comes first).
  registrationStrategy: 'registerWhenStable:30000'
})
   /*  ,InterceptorsModule */
    
  ],
  declarations: [
    AppComponent,
    APP_CONTAINERS,
    LoginComponent
  ],
  providers: [
    { provide: MAPS_CONFIG_TOKEN, useClass: AppSettingsService }
    ,{ provide: AUTH_SERVICE_PROVIDER_TOKEN, useClass: AuthenticationService, multi:false} 
    ,{ provide: ISSUE_IMAGE_BASE_DIR_TOKEN, useValue: {baseUrl:environment.issueimagebasedir} }
    ,AuthGuard
    ,{
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    }    
    ,{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true } 
    ,{ provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } }
    ,{ provide: MAT_DATE_LOCALE, useValue: 'en-GB'}
    ,{ provide: RouteReuseStrategy, useClass: AppReuseStrategy}
    /* , fakeBackendProvider */
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    injector: Injector
  ) {
    AppInjector.setInjector(injector);
    //for static methods in libraries
    AppSharedConfig.issueimagebasedir= environment.issueimagebasedir;
  }
 }

//{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
//,{provide: UPLOAD_SERVICE_CONFIG_TOKEN, useValue: environment.API_UPLOAD_ENDPOINT} 